import React from 'react';
import { Helmet } from 'react-helmet';  // Importera Helmet

function Kontorsstadning() {
  return (
    <>
    <Helmet>
            <title>Professionell Kontorsstädning – Effektivt & Flexibelt – Provalt Service AB</title>
            <meta name="description" content="Skräddarsydd kontorsstädning som skapar en trivsam och produktiv arbetsmiljö. Vi erbjuder daglig och djuprengöring anpassad efter dina behov." />
          <link rel="canonical" href="https://provalt.se/kontorsstadning" />
        </Helmet>
        <section
            className="relative h-[40vh] bg-cover bg-center flex items-center justify-center text-white"
            style={{
                backgroundImage: "url('/images/cleaning/kontorsstadning-provalt.webp')",
            }}
            >
            {/* Skuggöverlägg */}
            <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />

            {/* Textinnehåll */}
            <div className="relative z-10 text-center p-7 bg-black bg-opacity-30 z-0">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">Kontorsstädning</h1>
                <p className="text-xl md:text-2xl font-bold">
                För en ren och trivsam arbetsplats
                </p>
            </div>
        </section>
        <section className="py-16 px-6 md:px-12 bg-white text-gray-800">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-1xl md:text-2xl font-bold mb-6">
                Välkommen till Provalt Service AB – Professionell Kontorsstädning för en Ren och Trivsam Arbetsplats
                </h2>
                <p className="mb-10 text-lg">
                Vi på Provalt Service AB hjälper företag och organisationer att hålla sina kontor skinande rena – för en hälsosam och produktiv arbetsmiljö.
                Med vår erfarna och engagerade personal kan vi garantera hög kvalitet på både städning och kundbemötande, alltid till konkurrenskraftiga priser.
                </p>
                <p className="mb-10 text-lg">
                Oavsett om ni har ett litet kontor eller ett större företagskomplex, anpassar vi våra städtjänster efter era behov.
                Vi är självklart anslutna till kollektivavtal, har ansvarsförsäkring och erbjuder kvalitetsgaranti – så att ni alltid kan känna er trygga med att anlita oss.
                </p>

                <h2 className="text-3xl md:text-4xl font-semibold mb-6">Detta ingår i kontorsstädning</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                    <h4 className="text-xl font-semibold mb-2">Arbetsplatser & Gemensamma Ytor</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Dammtorkning av skrivbord, stolar och hyllor</li>
                    <li>Rengöring av datorer, tangentbord och telefoner (vid behov)</li>
                    <li>Putsning av glasytor och speglar</li>
                    <li>Tömning av papperskorgar och återvinningskärl</li>
                    </ul>

                    <h4 className="text-xl font-semibold mt-6 mb-2">Golvvård</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Dammsugning och moppning av golv</li>
                    <li>Rengöring av mattor och entréområde</li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-xl font-semibold mb-2">Kök & Personalrum</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Rengöring av diskbänk och bänkskivor</li>
                    <li>Avtorkning av bord, stolar och skåpluckor</li>
                    <li>Tömning av sopor och återvinning</li>
                    <li>Rengöring av kaffemaskin, mikrovågsugn och andra vitvaror</li>
                    </ul>

                    <h4 className="text-xl font-semibold mt-6 mb-2">Toaletter & Hygienutrymmen</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Rengöring och desinficering av toaletter, handfat och kranar</li>
                    <li>Påfyllning av toalettpapper, tvål och pappershanddukar</li>
                    <li>Tömning av papperskorgar</li>
                    </ul>
                </div>
                </div>

                <div className="mt-12">
                <h4 className="text-3xl md:text-4xl font-semibold mb-4">Tilläggstjänster</h4>
                <ul className="list-disc list-inside space-y-2">
                    <li><strong>Fönsterputsning –</strong> Både invändig och utvändig rengöring av fönster för ett fräscht intryck.</li>
                    <li><strong>Djuprengöring av golv –</strong> Skurning, polering och vaxning av golv för längre hållbarhet.</li>
                    <li><strong>Mattvätt & Textilrengöring –</strong> Professionell rengöring av heltäckningsmattor och kontorsstolar.</li>
                    <li><strong>Påfyllning av förbrukningsmaterial –</strong> Leverans och påfyllning av toalettpapper, tvål, pappershanddukar, diskmedel m.m.</li>
                </ul>
                </div>
            </div>
        </section>
        <section className="py-16 bg-gray-50">
            <div className="container mx-auto px-4 grid md:grid-cols-2 gap-10 items-start">
                {/* Textinnehåll */}
                <div>
                <h2 className="text-3xl font-bold mb-4">Kontakta oss idag för en kostnadsfri offert!</h2>
                <p className="mb-4">
                    Låt oss ta hand om städningen så att ni kan fokusera på er verksamhet. Oavsett om ni behöver daglig,
                    veckovis eller mer omfattande kontorsstädning, ser vi till att ert kontor alltid är skinande rent och inbjudande.
                </p>
                <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                    <li>Skräddarsydda lösningar anpassade efter era behov</li>
                    <li>Flexibla tider – anpassade efter era behov</li>
                    <li>Kvalitetsgaranti – anpassade efter era behov</li>
                    <li>Miljövänliga & skonsamma produkter för en hälsosam arbetsmiljö</li>
                </ul>
                <p className="mb-2 font-semibold">Begär en offert idag!</p>
                <p className="text-gray-700">Fyll i vårt kontaktformulär så återkommer vi snabbt med ett förslag som passar just ert företag.</p>
                <p className="text-gray-700 mt-2"><b>Vill du veta mer?</b> Vi svarar gärna på frågor och berättar hur vi kan hjälpa just er!</p>
                </div>

                {/* Formulär */}
                <form className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <div>
                    <label className="block text-sm font-medium mb-1">Namn</label>
                    <input type="text" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">E-post</label>
                    <input type="email" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Telefonnummer</label>
                    <input type="tel" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Ämne</label>
                    <input type="text" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Meddelande</label>
                    <textarea className="w-full border rounded p-2 h-28 resize-none" />
                </div>
                <button
                    type="submit" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full font-semibold">
                    Skicka
                </button>
                </form>
            </div>
        </section>
    </>
  );
}

export default Kontorsstadning;
